import React, { useEffect, useState } from "react";
import {
  FiSave,
  FiRefreshCw,
  FiSettings,
  FiInfo,
} from "react-icons/fi";
import api from "../../utills/api";

const Organization = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [organization, setOrganization] = useState({
    name: "",
    type: "College",
    academicYear: "",
    timezone: "Asia/Kolkata",
  });

  const [message, setMessage] = useState("");

  const loadOrganization = async () => {
    try {
      setLoading(true);
      setMessage("");

      const response = await api.get("/organization");

      const data = response?.data?.data || response?.data || {};

      setOrganization({
        name: data.name || "",
        type: data.type || "College",
        academicYear: data.academicYear || "",
        timezone: data.timezone || "Asia/Kolkata",
      });
    } catch (error) {
      console.error("Failed to load organization:", error);

      setMessage(
        error?.response?.data?.message ||
          "Unable to load organization details."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadOrganization();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setOrganization((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setSaving(true);
      setMessage("");

      await api.put("/organization", organization);

      setMessage("Organization settings saved successfully.");
    } catch (error) {
      console.error("Failed to save organization:", error);

      setMessage(
        error?.response?.data?.message ||
          "Unable to save organization settings."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 className="mb-1">Organization</h4>
            <p className="text-muted mb-0">
              Manage your education organization settings.
            </p>
          </div>

          <button
            type="button"
            className="btn btn-light"
            onClick={loadOrganization}
            disabled={loading}
          >
            <FiRefreshCw
              size={15}
              className={loading ? "spin me-1" : "me-1"}
            />
            Refresh
          </button>
        </div>

        {message && (
          <div className="alert alert-info">
            <FiInfo size={16} className="me-2" />
            {message}
          </div>
        )}

        <div className="card">
          <div className="card-header">
            <h5 className="card-title mb-0">
              <FiSettings size={17} className="me-2" />
              Organization Details
            </h5>
          </div>

          <div className="card-body">
            {loading ? (
              <div className="text-center py-5">
                Loading organization...
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      Organization Name
                    </label>

                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={organization.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      Organization Type
                    </label>

                    <select
                      name="type"
                      className="form-select"
                      value={organization.type}
                      onChange={handleChange}
                    >
                      <option value="School">School</option>
                      <option value="College">College</option>
                      <option value="University">
                        University
                      </option>
                      <option value="Coaching Institute">
                        Coaching Institute
                      </option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      Academic Year
                    </label>

                    <input
                      type="text"
                      name="academicYear"
                      className="form-control"
                      placeholder="2026-27"
                      value={organization.academicYear}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-6 mb-3">
                    <label className="form-label">
                      Timezone
                    </label>

                    <select
                      name="timezone"
                      className="form-select"
                      value={organization.timezone}
                      onChange={handleChange}
                    >
                      <option value="Asia/Kolkata">
                        Asia/Kolkata
                      </option>
                      <option value="UTC">UTC</option>
                    </select>
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving}
                  >
                    <FiSave size={15} className="me-1" />
                    {saving ? "Saving..." : "Save Changes"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Organization;